import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import HttpApi from "i18next-http-backend";

i18n
    .use(HttpApi)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        fallbackLng: "en",
        supportedLngs: ["en", "zh"],
        ns: ["translations"],
        defaultNS: "translations",
        backend: {
            loadPath: "./locales/{{lng}}.json", // 指定语言文件路径
        },
        detection: {
            order: ["querystring", "cookie", "localStorage", "navigator"],
            caches: ["cookie"],
        },
        debug: false,
        interpolation: {
            escapeValue: false,
        },
    });

export default i18n;
